import { PAYMENT_ACTIVITY_VIEW_ACCESS } from '../../../security.attributes';
export default (function ($stateProvider) {
  $stateProvider.state('index.customercare.customer.totals', {
    url: '/totals',
    template: '<totals></totals>',
    securityAttributes: [PAYMENT_ACTIVITY_VIEW_ACCESS]
  });
});